import TextTitle from 'components/elements/texts/TextTitle'
import React from 'react'
import styled from 'styled-components'

/**
 * 画面上部のタイトル表示エリア
 */
const TitleArea: React.FC<TitleAreaProps> = (props) => {
  return (
    <React.Fragment>
      {props.title && (
        <StyledTitleArea>
          <TextTitle color={props.color}>{props.title}</TextTitle>
        </StyledTitleArea>
      )}
    </React.Fragment>
  )
}

export type TitleAreaProps = {
  title?: string
  color?: string
}

const StyledTitleArea = styled.div`
  margin-top: 56px;
  text-align: center;
`

export default TitleArea
